import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { renderCell } from './utility/rms-data-grid-helper';

const RMSDataGridRow = ({
  row,
  columns,

  enableRowReorder = false,

  innerRef,
  draggableProps,
  dragHandleProps,

  renderActions,
  onRowClick,
}) => {
  return (
    <TableRow
      hover
      ref={innerRef}
      {...draggableProps}
      className={onRowClick ? 'is-clickable' : undefined}
      onClick={onRowClick ? () => onRowClick(row) : undefined}>
      {enableRowReorder && (
        <TableCell
          width={40}
          align="center"
          {...dragHandleProps}
          style={{
            width: 40,
            cursor: 'grab',
          }}>
          <DragIndicatorIcon fontSize="small" color="action" />
        </TableCell>
      )}

      {columns.map((column) => (
        <TableCell key={column.field} style={column.width ? { width: column.width } : undefined}>
          {renderCell(column, row)}
        </TableCell>
      ))}

      {renderActions && (
        <TableCell align="center" onClick={onRowClick ? (event) => event.stopPropagation() : undefined}>
          {renderActions(row)}
        </TableCell>
      )}
    </TableRow>
  );
};

export default React.memo(RMSDataGridRow);
